angular.module('iw.frontyard.signup')
    .service('SignupPageHelper', function ($window,
                                           BrokerSignupPage,
                                           SignupPage) {

        class SignupPageHelper {

            static retrieveSignupPage() {
                switch ($window.USER_IS_BROKER) {
                    case true:
                        return new BrokerSignupPage();
                    default:
                        return new SignupPage();
                }
            }

        }

        return SignupPageHelper;
    });